<template>
  <div class="my-account">
    <div class="alert alert-danger" v-if="error">{{error}}</div>
    <div id="find_service" class="special-form">
      <select-input v-model="profileId" :options="options" name="PROFILE" label="Профиль"></select-input>
      <text-input v-model="orderId" name="ORDER_ID" label="Номер заказа aitech-service.ru"></text-input>

      <btn @click="getBill()" :title="'Получить счет'"></btn>
    </div>
    <div class="row">
      <div class="col-md-12 table-responsive">
        <table>
          <thead>
          <tr>
            <th>Код заказа</th>
            <th>Стоимость</th>
            <th class="cart-history-status">Статус</th>
            <th style="width: 150px;">Действия</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="order of orders">
            <td><b>{{order.ID}}</b><br></td>
            <td>{{Math.round(order.PRICE * 100) / 100}} руб.</td>
            <td class="cart-history-status" v-html="order.STATUS"></td>
            <td class="sb_worck_order">
              <span v-if="order.CANCELED" class="sb-payfinal_span-red">ОТМЕНЕН</span>
              <template v-else>
                <template v-if="order.PAYED">
                  <span class="sb-payfinal_span">ОПЛАЧЕН {{order.IS_ORDER_LC_PAY ? 'с ВС' : ''}} </span>
                </template>
                <template v-else>
                  <template v-if="order.PRICE > 0">
                    <a target="_blank" class="defect-button" title="Посмотреть счет"
                       :href="'/personal/service/report.php?ORDER_ID=' + order.ID">Посмотреть
                      счет</a><br>
                    <a target="_blank" class="defect-button" title="Скачать счет"
                       :href="'/personal/service/report.php?pdf=1&ORDER_ID=' + order.ID">Скачать
                      счет</a><br>
                  </template>
                  <template v-if="order.IS_LC_PAY">
                    <a target="_blank" class="defect-button"
                       title="Оплатить с ВС" href="#" @click="payLc(order.ID, $event)">Оплатить с ВС</a>
                    <br>
                  </template>
                  <template v-else-if="order.PRICE > 0">
                    <a class="red-button" title="Пополнить ВС"
                       href="/personal/account/prepaid.php">Пополнить ВС</a><br>
                  </template>
                </template>
              </template>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <loader v-if="loading"></loader>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import SelectInput from '../form/SelectInput'
  import TextInput from '../form/TextInput'
  import Loader from '../Loader'
  import Btn from '../form/Btn'

export default {
    name: 'bill',
    components: {Btn, Loader, TextInput, SelectInput},
    computed: {
      ...mapGetters('bill', [
        'orders',
        'error',
        'loading'
      ]),
      ...mapGetters('profile', [
        'getProfileList'
      ]),
      profileId: {
        get () {
          return this.$store.getters['bill/profileId']
        },
        set (profileId) {
          this.$store.commit('bill/setProfileId', {profileId})
        }
      },
      orderId: {
        get () {
          return this.$store.getters['bill/orderId']
        },
        set (orderId) {
          this.$store.commit('bill/setOrderId', {orderId})
        }
      },
      profiles () {
        return this.getProfileList.filter(e => e.typeId === 2)
      },
      options () {
        let options = []
        options.push({
          value: '',
          title: 'Не выбрано'
        })
        for (let profile of this.profiles) {
          options.push({
            value: profile.id,
            title: profile.name
          })
        }

        return options
      }
    },
    created () {
      if (this.orders.length <= 0) {
        this.$store.dispatch('bill/fetchOrders')
      }

      this.$store.dispatch('profile/updateProfileList')
    },
    methods: {
      async payLc (orderId, $event) {
        $event.preventDefault()
        await this.$store.dispatch('orders/payLc', {orderId})
        await this.$store.dispatch('bill/fetchOrders')
      },
      getBill () {
        this.$store.dispatch('bill/getBill')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .my-account {
    position: relative;
  }

  #find_service, .my-account__money {
    text-align: center;
  }

  input[type="text"] {
    padding: 10px;
    min-width: 280px;
    height: 30px;
    font-size: 14px;
    border: 1px solid #eeeeee;
    &:hover {
      border: 1px solid #00B770;
    }
  }

  #loader {
    display: none;
    .container {
      position: absolute;
      top: 50%;
      left: 50%;
    }
  }

  .banner {
    position: relative;
    padding: 10px 20px;
    animation: loader 1s cubic-bezier(0.5, 0.1, 0.15, 1) alternate infinite;
    color: #EB8C79;
    font-family: 'Open Sans';
  }

  @keyframes loader {
    0% {
      letter-spacing: -1px;
    }

    100% {
      letter-spacing: 15px;
    }
  }

  .my-account__button.button {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .table-standart_light tr td {
    padding: 20px 10px !important;
  }

  .defect-button {
    font-size: 14px;
    color: rgb(0, 183, 112);
    text-decoration: underline;
    &:hover {
      color: #6AD2AA;
    }
  }

  .red-button {
    font-size: 14px;
    color: rgb(183, 26, 0);
    text-decoration: underline;
    &:hover {
      color: #d26f7a;
    }
  }

  .sp_list {
    min-width: 280px;
    height: 30px;
    font-size: 14px;
    #profileList {
      min-width: 280px;
    }
  }

  .sb-payfinal_span {
    font-size: 14px;
    font-weight: bold;
    color: rgb(255, 255, 255);
    padding: 5px 10px;
    text-align: center;
    background-color: rgb(0, 183, 112);
  }

  .sb-payfinal_span-red {
    font-size: 14px;
    color: rgb(255, 255, 255);
    font-weight: bold;
    padding: 5px 10px;
    text-align: center;
    background-color: rgb(247, 103, 101);
  }

  .pb-3 {
    padding-bottom: 20px !important;
  }

  .pr-3 {
    padding-right: 20px !important;
  }

  .sb-flex-right {
    display: flex;
    justify-content: flex-end;
  }

  .sb-btn-dynamic-red {
    width: 30px;
    height: 30px;
    right: 0px;
    background-color: #d43f3a;
    border-color: #d43f3a;
    color: #fff;
  }

  @media (min-width: 768px) {
    #payOrderModal .modal-dialog {
      width: 50%;
    }
  }

  .sb-akt-button {
    color: rgb(136, 173, 159);
  }

  .sb_worck_order {
    vertical-align: middle !important;
    text-align: center;
  }

  .sb-delete-akt {
    color: red !important;
  }

  .sb-btn-collapsed {
    border: none;
    padding: 0 30px;
    margin-top: 20px;
    background-color: rgb(0, 183, 112);
    height: 25px;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/Personal/Bill.vue